import { useRecoilState } from 'recoil'
import useDebounce from 'shared/hooks/useDebounce'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import checkResultsTableAtom from './checkResultsTable.atom'
import inspectionApi from '../../inspection.api'
import { InspectorCheckResult } from '../../inspection.types'
import checkResultsTableFields from './checkResultsTable.fields'
import SearchInput from 'shared/Inputs/SearchInput'

interface ICheckResultsTableProps {
  checkpointId?: string
}

const CheckResultsTable = (props: ICheckResultsTableProps) => {
  const navigate = useNavigate()
  const [state, setState] = useRecoilState(checkResultsTableAtom)
  const debouncedSearch = useDebounce(state.filters.search, 400)

  const handleRowClick = useCallback(
    (item: InspectorCheckResult) => {
      if (props.checkpointId) {
        navigate(`/checkpoint-inspection/${props.checkpointId}/submission/${item.id}`)
      }
    },
    [navigate, props.checkpointId]
  )

  const handleChange = (value: any, name: string) => {
    setState((prev) => ({ ...prev, filters: { ...prev.filters, [name]: value } }))
  }

  const fetcher = useCallback(
    (params: Record<string, any>) => {
      return inspectionApi.getInspectorCheckResults({
        checkpointId: props.checkpointId,
        search: debouncedSearch || undefined,
        ...params,
      })
    },
    [debouncedSearch, props.checkpointId]
  )

  const itemsSetter = useItemsSetter(checkResultsTableAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: checkResultsTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'checkResults',
    serverSideOrder: true,
  })

  const filteredItems = useMemo(() => {
    return tableCtrl.orderedItems.filter((item) => item.checkpointId === props.checkpointId)
  }, [tableCtrl.orderedItems, props.checkpointId])

  return (
    <>
      <div style={{ margin: '1em 0em' }}>
        <SearchInput
          value={state.filters.search || ''}
          name='search'
          onChange={handleChange}
          required={false}
          placeholder='Поиск'
          autofocus={true}
        />
      </div>
      <Table
        {...tableCtrl}
        items={filteredItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof InspectorCheckResult>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        itemKey='id'
        selectEnabled={false}
        onCLick={handleRowClick}
      />
    </>
  )
}

export default CheckResultsTable
